/*
 * Cart Smart Recommendations — "Bought with together" row arrow navigation.
 *
 * Must be a custom element (like the theme's <mini-cart>, <add-to-cart>,
 * <cart-recommendations>), NOT a plain <script>. The cart drawer's markup is
 * always injected via `element.innerHTML = ...` — both on first load
 * (assets/cart-drawer.js MiniCart.handleIntersection) and on every AJAX cart
 * update (MiniCart.renderContents) — and innerHTML-inserted <script> tags never
 * execute, ever. Custom elements, however, upgrade automatically whenever their
 * tag is inserted into a connected document by any means, so this reliably wires
 * up the arrows every time the row renders. This file is loaded once, normally,
 * from sections/header.liquid (next to cart-recommendations.js) — never from
 * inside mini-cart.liquid itself.
 */
class CsrBoughtTogether extends HTMLElement {
  connectedCallback() {
    this.strip = this.querySelector('[data-csr-strip]');
    this.prev = this.querySelector('.csr__arrow--prev');
    this.next = this.querySelector('.csr__arrow--next');
    if (!this.strip || !this.prev || !this.next) return;

    this.prev.addEventListener('click', () => this.scrollByStep(-1));
    this.next.addEventListener('click', () => this.scrollByStep(1));
  }

  scrollByStep(direction) {
    const item = this.strip.querySelector('.csr__item');
    const step = item ? item.getBoundingClientRect().width + 12 : this.strip.clientWidth * 0.6;
    this.strip.scrollBy({ left: direction * step, behavior: 'smooth' });
  }
}
customElements.define('csr-bought-together', CsrBoughtTogether);
